import type { ApplicationRole as ApplicationRoleModel } from '@/adapters/catalogv1.g';

export function extractApplicationRole(model: ApplicationRoleModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    applicationRef: model.application_ref ?? '',
    roleRef: model.role_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplicationRole = ReturnType<typeof extractApplicationRole>;
